// extracted by mini-css-extract-plugin
export var li = "ProductList-module--li--42126";
export var ul = "ProductList-module--ul--f5701";